import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "../store";

const blogsState = (state: RootState) => state.blogs;

const selectBlogs = createSelector(blogsState, (state) => state.blogs || []);

export const blogsSliceSelectors = { selectBlogs };
